module.exports = __webpack_public_path__ + "img/email.a2a21f10.svg";